import { Button } from "@mantine/core";
import { useRouter } from "@tanstack/react-router";

export function NotFound() {
  const { history } = useRouter();

  const handleBack = () => {
    history.back();
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 px-4">
      <h1 className="mb-4 text-6xl font-bold text-gray-800">404</h1>
      <p className="mb-6 text-xl text-gray-600">Página não encontrada</p>

      <Button onClick={handleBack}>Voltar</Button>
    </div>
  );
}
